import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Button,
  Typography,
  TextField,
  CircularProgress,
  Paper,
  Box,
  InputAdornment,
  Chip
} from '@mui/material';
import {
  Search,
  ArrowBack,
  FileDownload,
  Analytics,
  Person
} from '@mui/icons-material';
import { useStateValue } from '../../contexto/store';
import { obtenerRespuestasEncuesta, obtenerEncuesta } from '../../actions/EncuestaAction';
import TRespuestas from './TRespuestas';

export default function RespuestasEncuesta(props) {
  // eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [term, setTerm] = useState('');
  const [respuestas, setRespuestas] = useState([]);
  const [encuesta, setEncuesta] = useState(null);
  const [datosCargados, setDatosCargados] = useState(false);
  const [encuestaId] = useState(props.match?.params?.encuestaId || props.encuestaId);

  const volverAMisEncuestas = () => {
    props.history.push('/mis-encuestas');
  };

  const exportarRespuestas = () => {
    // Implementar lógica de exportación (CSV, PDF, etc.)
    console.log('Exportando respuestas...');
  };

  const verAnaliticas = () => {
    props.history.push(`/analiticas/${encuestaId}`);
  };

  const cargarDatos = async () => {
    setDatosCargados(false);
    try {
      // Cargar detalles de la encuesta y sus respuestas en paralelo
      const [respuestasResponse, encuestaResponse] = await Promise.all([
        obtenerRespuestasEncuesta(encuestaId),
        obtenerEncuesta(encuestaId)
      ]);

      if (respuestasResponse.status === 200) {
        setRespuestas(respuestasResponse.data);
      } else {
        console.log('ERROR EN OBTENER RESPUESTAS');
      }

      if (encuestaResponse.status === 200) {
        setEncuesta(encuestaResponse.data);
      } else {
        console.log('ERROR EN OBTENER DETALLE ENCUESTA');
      }

      setDatosCargados(true);
    } catch (error) {
      console.error('Error al cargar datos:', error);
      setDatosCargados(true);
    }
  };

  useEffect(() => {
    if (encuestaId) {
      cargarDatos();
    }
  }, [encuestaId]);

  // const handleRespuestaEliminada = (respuestaEncuestaId) => {
  //   setRespuestas(prevRespuestas =>
  //     // Corregido para usar 'respuestaEncuestaId' que es la clave correcta
  //     prevRespuestas.filter(respuesta => respuesta.respuestaEncuestaId !== respuestaEncuestaId)
  //   );
  // };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header con información de la encuesta */}
      {encuesta && (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
            borderRadius: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={volverAMisEncuestas}
              sx={{
                backgroundColor: 'rgba(255,255,255,0.2)',
                color: 'white',
                borderColor: 'rgba(255,255,255,0.5)',
                backdropFilter: 'blur(10px)',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                  borderColor: 'white',
                },
              }}
            >
              Volver
            </Button>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
            <Box>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}>
                {encuesta.titulo}
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.9)', mb: 1 }}>
                {encuesta.descripcion}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Chip
                  icon={<Person />}
                  label={`${respuestas.length} respuesta${respuestas.length === 1 ? '' : 's'}`}
                  sx={{
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    color: 'white',
                    fontWeight: 500,
                    backdropFilter: 'blur(10px)',
                  }}
                />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                startIcon={<Analytics />}
                onClick={verAnaliticas}
                sx={{
                  backgroundColor: 'white',
                  color: '#0d47a1',
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.9)',
                  },
                }}
              >
                Ver Analíticas
              </Button>
              {/* <Button
                variant="outlined"
                startIcon={<FileDownload />}
                onClick={exportarRespuestas}
                sx={{
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  borderColor: 'rgba(255,255,255,0.5)',
                  backdropFilter: 'blur(10px)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.3)',
                    borderColor: 'white',
                  },
                }}
              >
                Exportar
              </Button> */}
            </Box>
          </Box>
        </Paper>
      )}
      
      {/* Barra de búsqueda moderna */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar en las respuestas..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'background.default',
              '&:hover': {
                backgroundColor: 'action.hover',
              },
              '&.Mui-focused': {
                backgroundColor: 'background.paper',
              },
            },
          }}
        />
      </Paper>

      {/* Contenido principal */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {datosCargados ? (
          respuestas.length > 0 ? (
            <TRespuestas
              rows={respuestas}
              termp={term}
            />
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: 8,
                gap: 2,
              }}
            >
              <Typography variant="h6" color="text.secondary">
                Aún no hay respuestas para esta encuesta.
              </Typography>
            </Box>
          )
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} thickness={4} />
            <Typography variant="h6" color="text.secondary">
              Cargando respuestas...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
}